import { render } from "./PredictionMarketDetail.vue?vue&type=template&id=720d5407"
import script from "./PredictionMarketDetail.vue?vue&type=script&lang=js"
export * from "./PredictionMarketDetail.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/PredictionMarketDetail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "720d5407"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('720d5407', __exports__)) {
    api.reload('720d5407', __exports__)
  }
  
  module.hot.accept("./PredictionMarketDetail.vue?vue&type=template&id=720d5407", () => {
    api.rerender('720d5407', render)
  })

}


export default __exports__